(function () {

    'use strict';

    const STATES = [
        {
            "name": "delivery_term",
            "label": "states_delivery_term",
        }
    ];

    const {BehaviorSubject} = require("rxjs");

    class PregnancyReport {
        constructor(genericStatesService, system, $translate, $scope, $state, $stateParams, moment) {
            this.genericStatesService = genericStatesService;
            this.system = system;
            this.translate = $translate;
            this.scope = $scope;
            this.$state = $state;
            this.moment = moment;
            this.dateFormat = system['date_format'].js;

            this.currentState = genericStatesService.getCurrentState("pregnancy_delivery");

            this.isChart = false;
            this.states = STATES;
            this.activeState = _.get(this.states, '0');


            this.query = {
                start: $stateParams.start || this.moment().startOf('month').format(this.dateFormat),
                end: $stateParams.end || this.moment().endOf('month').format(this.dateFormat),
            };

            this.headers = {
                delivery_term: {
                    _id: {
                        type: "number",
                        caption: this.translate.instant('unique_id')
                    },
                    patient_id: {
                        type: "number",
                        caption: this.translate.instant('unique_id')
                    },
                    patient_fullname: {
                        type: "string",
                        caption: this.translate.instant('dcm_patient_full_name')
                    },
                    patient_birth_date: {
                        type: "date string",
                        caption: this.translate.instant('current_patient_birth_date')
                    },
                    delivery_term: {
                        type: "date string",
                        caption: this.translate.instant('pregnancy_delivery_term')
                    },
                    amenorrhea_start: {
                        type: "date string",
                        caption: this.translate.instant('first_day_in_last_cycle')
                    },
                    estimated_pregnancy_date: {
                        type: "date string",
                        caption: this.translate.instant('edited_pregnancy_date')
                    },


                }
            };
            this.$dataSource = new BehaviorSubject({
                slice: {},
                data: [],
                headers: {},
                onlyData: false
            });
        }

        static get $inject() {
            return ["genericStatesService", "system", "$translate", "$scope", "$state", "$stateParams", "moment"];
        }

        $onInit() {
            this.maxDate = this.moment().add(9, "months").toDate();
            this.getData();
        }


        getSlice() {
            return {
                "expands": {
                    "expandAll": true,
                    "rows": [
                        {"tuple": []}
                    ]
                },
                "drills": {
                    "drillAll": false
                },
                "rows": this.getRows(),
                "columns": this.getColumns(),
                "measures": this.getMeasures()
            };
        }


        getRows() {
            if (this.activeState.name === 'delivery_term')
                return [
                    {
                        "uniqueName": "patient_fullname"
                    }
                ];
        }

        getColumns() {
            if (this.activeState.name === 'delivery_term')
                return [
                    {
                        "uniqueName": "patient_birth_date"
                    },
                    {
                        "uniqueName": "amenorrhea_start"
                    },
                    {
                        "uniqueName": "estimated_pregnancy_date"
                    },
                    {
                        "uniqueName": "delivery_term"
                    }
                ];
        }


        getMeasures() {
            if (this.activeState.name === 'delivery_term')
                return [];
        }

        getData(onlyData = false) {
            this.promise = this.genericStatesService.getPregnancyReport(
                _.assign(this.query, {data_source: this.activeState.name})
            ).then(data => {
                if (onlyData) {
                    this.$dataSource.next({
                        onlyData: true,
                        data: data,
                    });
                } else {
                    this.$dataSource.next({
                        slice: this.getSlice(),
                        data: data,
                        headers: this.headers[this.activeState.name]
                    });
                }
            });
        }


        handleFileName() {
            const start = this.moment(this.query.start, this.dateFormat).format(this.genericStatesService.exportDateFormat);
            const end = this.moment(this.query.end, this.dateFormat).format(this.genericStatesService.exportDateFormat);

            return `${this.translate.instant('states_delivery_term_file_name', {start, end})}`;
        }

        handleStatesChange() {
            this.scope.$applyAsync(() => this.queryChanged(false));
        }

        queryChanged(onlyData = true) {
            const start = this.moment(this.query.start, this.dateFormat);
            const end = this.moment(this.query.end, this.dateFormat);

            if (start.isAfter(end)) this.query.end = start.endOf('month').format(this.dateFormat);

            this.$state.transitionTo(
                this.$state.current.name,
                this.query,
                {notify: false}
            ).then(() => this.getData(onlyData));
        }

        onComplete(instance) {

        }

        customizeCells(cellBuilder, cellData) {
        }
    }

    module.exports = PregnancyReport;
})();